<template>
    <div>
        <label :id="id"
               class="block text-sm leading-5 text-gray-700"
               :class="{ 'font-medium': ! this.bold, 'font-bold': this.bold }"
               v-html="label"
               v-if="label"
        ></label>
        <div class="mt-1 relative rounded-md shadow-sm">
            <select :id="id"
                    :name="name"
                    :value="value"
                    class="block form-select w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                    :class="{ 'border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red pr-10': error }"
                    :disabled="disabled"
                    @change="change"
            >
                <template v-for="option in options">
                    <option :value="option[trackBy]" v-if="! option.options">
                        {{ option[displayBy] }}
                    </option>

                    <optgroup :label="option[displayBy]" v-else>
                        <option :value="subOption[trackBy]" v-for="subOption in option.options">
                            {{ subOption[displayBy] }}
                        </option>
                    </optgroup>
                </template>
            </select>

            <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                 v-if="error"
            >
                <span class="bg-white">
                    <svg class="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                </span>
            </div>
        </div>

        <p class="mt-1 text-xs text-gray-400" v-if="! error">
            {{ description }}
        </p>

        <p class="mt-1 text-xs text-red-600" id="email-error">
            {{ error }}
        </p>
    </div>
</template>

<script>
	export default {
	    model: {
	        event: 'change',
        },

		props: {
		    label: {
		        type: String,
            },

            id: {
		        type: String,
            },

            name: {
		        type: String,
            },

            error: {
		        type: String,
            },

            placeholder: {
		        type: String,
            },

            value: {
		        required: true,
            },

            options: {
		        type: Array,
                required: true,
            },

            displayBy: {
                type: String,
                default: 'name'
            },

            trackBy: {
                type: String,
                default: 'id'
            },

            trackAsInteger: {
		        type: Boolean,
                default: false,
            },

            trackAsBoolean: {
		        type: Boolean,
                default: false,
            },

            bold: {
		        type: Boolean,
		        default: false,
            },

            disabled: {
		        type: Boolean,
                default: false,
            },

            description: {
                type: String,
            },
        },

        methods: {
	        change(e) {
	            if (e.target.value === 'null' || _.isNull(e.target.value) || e.target.value === '') {
                    return this.$emit('change', null);
                }

	            if (this.trackAsInteger) {
	                return this.$emit('change', parseInt(e.target.value));
                }

	            if (this.trackAsBoolean) {
                    return this.$emit('change', e.target.value === 'true');
                }

                this.$emit('change', e.target.value);
            }
        }
	}
</script>
